// extracted by mini-css-extract-plugin
module.exports = {"TabPanel":"TabPanel__TabPanel__1X4H9","Box":"TabPanel__Box__NyXap","Content":"TabPanel__Content__1QvaV","Settings":"TabPanel__Settings__1GZfD"};